<template>
  <v-container fill-height fluid grid-list-xl>
    <material-card
      color="green"
      flat
      full-width
      title="Баннеры на главной"
    >
      <v-data-table
        :loading="$apollo.loading"
        loading-text="Загрузка..."
        :headers="headers"
        :items="banner_area"
        :server-items-length="totalCount"
        :options.sync="options"
      >
        <template #top>
          <v-toolbar flat>
            <v-dialog v-model="dialog">
              <template #activator="{ on, attrs }">
                <v-btn
                  color="red"
                  dark
                  class="mb-2"
                  v-bind="attrs"
                  v-on="on"
                >
                  Новая запись
                </v-btn>
              </template>
              <v-card>
                <v-card-title>
                  <span class="headline">Добавление баннера</span>
                </v-card-title>
                <v-card-text>
                  <v-row>
                    <v-col sm="4">
                      <p><img src="~/assets/main_page_banners_scheme.png" style="width: 350px;"/></p>
                    </v-col>
                    <v-col sm="8">
                      <v-text-field
                        v-model="editedItem.position"
                        label="Позиция"
                      />
                      <v-text-field
                        v-model="editedItem.clickUrl"
                        label="Ссылка при клике"
                      />
                      <v-text-field
                        v-model="editedItem.description"
                        label="Описание"
                      />
                      <v-select
                        v-model="editedItem.status"
                        :items="statusList"
                        label="Статус"
                        single-line
                      />
                      <file-input :value="editedItem.images" bucket="image" :medias="medias" @change="setImage" />
                    </v-col>
                  </v-row>
                </v-card-text>
                <v-card-actions>
                  <v-spacer />
                  <v-btn color="blue darken-1" text @click="close">
                    Отмена
                  </v-btn>
                  <v-btn color="blue darken-1" text @click="save">
                    Сохранить
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-toolbar>
        </template>
        <template #item.actions="{ item }">
          <v-icon small class="mr-2" @click="editItem(item)">
            mdi-pencil
          </v-icon>
          <v-dialog
            transition="dialog-bottom-transition"
            width="500"
            :value="deleteDialog === item.id"
            @input="toggleDeleteDialog($event, item.id)"
          >
            <template #activator="{ on, attrs }">
              <v-tooltip top>
                <template #activator="{ on: tooltipActions, attrs: tooltipAttrs }">
                  <span v-bind="tooltipAttrs" v-on="tooltipActions">
                    <v-icon tag="i" v-bind="attrs" small class="mr-2" v-on="on">
                      mdi-delete
                    </v-icon>
                  </span>
                </template>
                Удалить
              </v-tooltip>
            </template>
            <v-card>
              <v-toolbar color="primary" dark class="text-center mb-6">
                Подтвердите Действие
              </v-toolbar>
              <v-card-text>
                Вы точно хотите удалить запись?
              </v-card-text>
              <v-card-actions class="justify-end">
                <v-btn color="tertiary" dark @click="deleteDialog = null">
                  Отменить
                </v-btn>
                <v-btn color="primary" @click="deleteItem(item.id)">
                  Удалить
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </template>
        <template #item.image="{ item }">
          <v-img
            width="200px"
            height="200px"
            contain
            :src="`${getImage(item)}`"
          />
        </template>
        <template #item.status="{ item }">
          {{ getStatus(item) }}
        </template>
      </v-data-table>
    </material-card>
  </v-container>
</template>

<script>
import { banner_area, addBannerItem, updateBannerItem, deleteBannerArea } from '@/graphql/banners'
import { getBannerMedias } from '@/graphql/banner_medias'
import { startCase, has } from 'lodash-es'
import FileInput from '~/components/banners/FileInput'

export default {
  name: 'Banners',
  components: {
    FileInput
  },
  layout: 'dashboard',
  apollo: {
    banner_area: {
      query: banner_area,
      variables () {
        return this.getBannersQueryVariables()
      },
      update: data => data.bannerArea.items.data,
      result ({ data }) {
        this.totalCount = data.bannerArea.items.totalCount
        this.selectedCategory = data.bannerArea.slug
      }
    },
    bannerMedias: {
      query: getBannerMedias,
      variables () {
      },
      update: data => data?.imageMedias,
      // update ({ data }) {
      //   return data?.map(item => [{ value: item.name, text: item.title }])
      // },
      result ({ data }) {
        this.mediasCount = data?.imageMedias?.length
      }
    }
  },
  data () {
    return {
      options: {
        page: 1,
        itemsPerPage: 10,
        multiSort: false
      },
      totalCount: 0,
      selectedCategory: null,
      medias: [],
      mediasCount: 0,
      active: [],
      open: [],
      deleteDialog: false,
      dialog: false,
      newItem: true,
      parentSlug: 'main_page_banners',
      editedItem: {},
      statusList: [
        { value: 'PUBLISHED', text: 'Активно' },
        { value: 'DRAFT', text: 'Не активно' }
        // { value: 'DELETED', text: 'Удалено' }
      ],
      statusListConverter: { 1: 'PUBLISHED', 0: 'DRAFT', '-1': 'DELETED' },
      headers: [
        ['id', 'Id'],
        ['image', 'Картинка'],
        ['description', 'Описание'],
        ['position', 'Позиция'],
        ['status', 'Статус'],
        ['actions', null]
      ]
          .map((colTitle) => {
            const [value, text] = Array.isArray(colTitle)
                ? colTitle
                : [colTitle, startCase(colTitle)]

            return {
              value,
              text,
              sortable: false
            }
          })
    }
  },
  computed: {
    bannersData () {
      return this.banner_areas ?? []
    }
  },
  watch: {
    selectedCategory () {
      this.options.page = 1
    },
    bannerMedias (value) {
      this.medias = value.map(item => ({ value: item.id, text: item.title }))
    },
    dialog (val) {
      if (val) {
        if (this.newItem) {
          this.editedItem = Object.assign({})
        }
      } else {
        this.newItem = true
      }
    }
  },
  methods: {
    getStatus (item) {
      if (has(this.statusListConverter, item.status)) {
        const ret = this.statusList.filter(row => row.value === this.statusListConverter[item.status])
        if (ret.length > 0) {
          return ret[0].text
        }
      }

      return item.status
    },
    setImage (images) {
      this.editedItem.images = images
    },
    getImage (item) {
      if (item.images != null && item.images.length > 0) {
        return item.images[0].file?.url
      } else {
        return ''
      }
    },
    getBannersQueryVariables () {
      return {
        slug: this.parentSlug,
        limit: this.options.itemsPerPage,
        offset: this.options.itemsPerPage * (this.options.page - 1)
      }
    },
    toggleDeleteDialog (value, slug) {
      this.deleteDialog = value
          ? slug
          : null
    },
    save () {
      this.editedItem.areaSlug = this.parentSlug
      this.editedItem.position = parseInt(this.editedItem.position)
      let newImages = []
      if (this.editedItem.images?.length > 0) {
        newImages = this.editedItem.images.map(item => ({ key: item.file.key, alt: item.alt, clickUrl: this.editedItem.clickUrl, media: item.media.id }))
      }
      if (this.newItem) {
        this.$apollo
          .mutate({
            mutation: addBannerItem,
            variables: {
              input: {
                description: this.editedItem.description,
                position: this.editedItem.position,
                areaSlug: this.editedItem.areaSlug,
                status: this.editedItem.status,
                images: newImages
              }
            }
          })
          .then((data) => {
            this.$apollo.queries.banner_area.refetch()
          })
          .catch((error) => {
            console.error(error)
          })
      } else {
        const id = this.editedItem.id
        this.$apollo
          .mutate({
            mutation: updateBannerItem,
            variables: {
              id,
              input: {
                description: this.editedItem.description,
                position: this.editedItem.position,
                areaSlug: this.editedItem.areaSlug,
                status: this.editedItem.status,
                images: newImages
              }
            }
          })
          .then((data) => {
            this.$apollo.queries.banner_area.refetch()
          })
          .catch((error) => {
            console.error(error)
          })
      }
      this.close()
    },
    deleteItem (id) {
      this.$apollo
          .mutate({
            mutation: updateBannerItem,
            variables: {
              id,
              input: {
                areaSlug: this.parentSlug,
                status: 'DELETED'
              }
            }
          })
          .then((data) => {
            this.$apollo.queries.banner_area.refetch()
          })
          .catch((error) => {
            console.error(error)
          })
    },
    editItem (item) {
      this.newItem = false
      this.editedItem = Object.assign({}, item)
      if (item.images.length > 0) {
        this.editedItem.clickUrl = item.images[0].clickUrl
        this.editedItem.images = this.editedItem.images.map(row => (
            row?.media?.id?.length > 0
                ? row
                : Object.assign(row, { media: { id: null, title: '', value: '', query: '' } })))
      }
      if (has(this.statusListConverter, item.status)) {
        this.editedItem.status = this.statusListConverter[item.status]
      }
      this.dialog = true
    },
    deleteBannerCategory (slug) {
      this.$apollo
          .mutate({
            mutation: deleteBannerArea,
            variables: {
              slug
            }
          })
          .then((data) => {
            this.$apollo.queries.banner_areas.refetch()
          })
          .catch((error) => {
            console.error(error)
          })
    },
    close () {
      this.dialog = false
    }
  }
}
</script>

<style scoped>

</style>
